// src/components/commissioner/CommissionerModeBar.js - COMPACT VERSION WITH NATIVE SELECT
import React from 'react';
import { Shield, X } from 'lucide-react';
import { dynastyTheme } from '../../services/colorService';
import { useCommissioner } from '../../contexts/CommissionerContext';

const CommissionerModeBar = ({ league, onTeamSwitch }) => {
  const { 
    isCommissionerMode, 
    activeTeamName, 
    activeTeamId,
    allTeams, 
    exitCommissionerMode, 
    switchTeam 
  } = useCommissioner();

  if (!isCommissionerMode) return null;

  const handleTeamChange = (teamId) => {
    console.log('CommissionerModeBar - Switching to team:', teamId);
    
    // Switch team in context
    switchTeam(teamId);
    
    // Call parent callback
    if (onTeamSwitch) {
      onTeamSwitch(teamId);
    }
  };

  const activeTeam = allTeams.find(t => t.team_id === activeTeamId);

  return (
    <div style={{
      position: 'sticky',
      top: 0,
      zIndex: 40,
      marginBottom: '10px'
    }}>
      <div style={{
        padding: '8px',
        borderRadius: '6px',
        border: '1px solid rgba(234, 179, 8, 0.5)',
        backgroundColor: 'rgba(234, 179, 8, 0.1)',
        backdropFilter: 'blur(4px)'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            flex: 1,
            minWidth: 0
          }}>
            <Shield style={{ width: '16px', height: '16px', color: '#fbbf24', flexShrink: 0 }} />
            <span style={{
              color: '#fbbf24',
              fontWeight: '600',
              fontSize: '12px',
              whiteSpace: 'nowrap'
            }}>
              Commissioner Mode
            </span>
            
            {/* Compact Team Selection - Use native select for mobile consistency */}
            <select
              value={activeTeamId || ''}
              onChange={(e) => handleTeamChange(e.target.value)}
              style={{
                marginLeft: '8px',
                flex: 1,
                minWidth: 0,
                maxWidth: '180px',
                padding: '4px 6px',
                fontSize: '11px',
                borderRadius: '4px',
                backgroundColor: '#1f2937',
                border: '1px solid rgba(234, 179, 8, 0.3)',
                color: '#ffffff',
                outline: 'none'
              }}
            >
              {allTeams.map(team => (
                <option key={team.team_id} value={team.team_id}>
                  {team.team_name}
                </option>
              ))}
            </select>
          </div>

          {/* Compact Exit Button */}
          <button
            onClick={() => exitCommissionerMode()}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              padding: '4px 8px',
              borderRadius: '4px',
              backgroundColor: 'rgba(239, 68, 68, 0.2)',
              border: 'none',
              color: '#f87171',
              fontSize: '11px',
              cursor: 'pointer',
              flexShrink: 0
            }}
            title="Exit Commissioner Mode"
          >
            <X style={{ width: '12px', height: '12px' }} />
            <span>Exit</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommissionerModeBar;